import axios from "axios";
import { BASE_API } from "./constant.js";
/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = (name) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + "=([^;]+)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return "";
  }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
}
const mimeMap = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
};
/**
 * 业务下载：区分于原生的downLoadZip
 * @param {*} path 接口相对路径，如：'/agent/register/download/importTemp'
 * @param {*} fileName 文件名，String类型，默认名称为当前时间戳
 * @param {*} fileExt 文件扩展名，当前支持3种格式：zip、xls、xlsx
 */
function downloadByBlob(path, fileName, fileExt = "xlsx") {
  if (!path) {
    throw new Error("path is necessary");
  }
  fileName = `${fileName}` + new Date().getTime() + "";
  var url = process.env.VUE_APP_BASE_API + path;
  axios({
    method: "get",
    url: url,
    responseType: "blob",
    headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    },
  }).then((res) => {
    console.log(res, "downloadByBlob");
    resolveBlobBiz(res, mimeMap[fileExt], fileName);
  });
}
/**
 * 解析blob响应内容并下载：改动了原有的resolveBlob函数，这里独立出来
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
function resolveBlobBiz(res, mimeType, fileName) {
  if (res.data.type == "application/json") {
    const reader = new FileReader();
    reader.readAsText(res.data, "utf-8");
    reader.onload = () => {
      console.info(reader.result);
      const errorData = JSON.parse(reader.result);
      this.$message({
        message: errorData.msg,
        type: "error",
      });
    };
  } else {
    const aLink = document.createElement("a");
    var blob = new Blob([res.data], {
      type: mimeType,
    });
    // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
    var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
    var contentDisposition = decodeURI(res.headers["content-disposition"]);
    var result = patt.exec(contentDisposition);
    var fileName = fileName.replace(/\"/g, "");
    aLink.style.display = "none";
    aLink.href = URL.createObjectURL(blob);
    aLink.setAttribute("download", fileName ? fileName : result[1]); // 设置下载文件名称
    document.body.appendChild(aLink);
    aLink.click();
    URL.revokeObjectURL(aLink.href); //清除引用
    document.body.removeChild(aLink);
  }
}

/**
 * 下载图片
 * @param src 路径
 * @param str 图片名
 *
 */
async function downloadImage(src, str = "img") {
  // 获取图片对象和画布对象
  const imgUrl = src;
  const response = await fetch(imgUrl);
  const blob = await response.blob();
  // 创建下载链接
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${str}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // 释放 Blob URL
  window.URL.revokeObjectURL(url);
}
// 校验 手机号
function vTelNum(value) {
  const reg =
    /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
  if (value && !reg) {
    return "手机号格式错误";
  }
}
// 校验 身份证号
function vTelNum(value) {
  const reg =
    /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
  if (value && !reg) {
    return "手机号格式错误";
  }
}

// 通用下载方法
function download(fileName) {
  console.log("data", fileName);
  window.location.href =
    getBaseUrl() +
    "/common/download?fileName=" +
    encodeURI(fileName) +
    "&delete=" +
    true;
}

export {
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  downloadByBlob,
  resolveBlobBiz,
  downloadImage,
  vTelNum,
  download,
};



// WEBPACK FOOTER //
// ./src/utils/util.js